import { Helmet } from "fusion-plugin-react-helmet-async";
import Footer from "../shared/components/footer";
import Navbar from "../shared/components/navbar";
import { assetUrl } from "fusion-core";
import { useNavigate } from "fusion-plugin-react-router";

const mainCss = assetUrl("../styles/main.css");
const css = assetUrl("../styles/notFound.css");

const notFound = assetUrl("../assets/icons/notFound.svg");

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
        />
        <link rel="stylesheet" href={mainCss} />
        <link rel="stylesheet" href={css} />
      </Helmet>

      <Navbar />
      <div className="mainBody">
        <div className="flex">
          <div className="form container">
            <img src={notFound} className="margin-top-30 image" />
            <h1 className="margin-top-30">
              Signals got crossed, and we can't find your page
            </h1>
            <p className="margin-top-15 margin-bottom-0">
              Let's get you where you want to go. Please check your URL or
              select one of the destinations below.
            </p>

            <button
              className="getStartedButton margin-top-30 margin-bottom-30"
              type="button"
              onClick={() => {
                navigate(-1);
              }}
            >
              Go Back
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default NotFound;
